export default {
  BY_OWNER: 'by-owner',
  CARS: 'cars',
  CERTIFIED: 'certified',
  CONNECTOR: 'and',
  DEALER: 'dealer',
  NEW: 'new',
  ONLINE: 'online',
  OVER: 'over',
  RANGE: 'between',
  UNDER: 'under',
  USED: 'used'
};